import * as React from "react";
import { Slot } from "radix-ui";
import { cn } from "@/lib/utils";

export type FrButtonVariant =
  | "ghost"
  | "gold"
  | "gold-gradient"
  | "outline-gold"
  | "danger"
  | "danger-outline"
  | "accent"
  | "link";

export type FrButtonSize = "sm" | "md" | "lg" | "block";

export interface ButtonProps extends React.ComponentProps<"button"> {
  variant?: FrButtonVariant;
  size?: FrButtonSize;
  asChild?: boolean;
}

/**
 * Fairway Rivalry button. Keeps the shadcn `asChild` (radix Slot)
 * pattern but is styled with the original `.btn` looks
 * (ghost, gold, danger, ...).
 */
function Button({
  className,
  variant = "ghost",
  size = "md",
  asChild = false,
  type,
  ...props
}: ButtonProps): React.JSX.Element {
  const Comp = asChild ? Slot.Root : "button";
  return (
    <Comp
      data-slot="button"
      data-variant={variant}
      data-size={size}
      type={asChild ? undefined : (type ?? "button")}
      className={cn("fr-btn", className)}
      {...props}
    />
  );
}

export { Button };
